import {ZodTypeAny} from 'zod';
import {AgentContext, AgentScratchpadContext, StandaloneAgent, Tool} from '../../copilot.types';
import getDefaultLLMModel from '../../models/utils/getDefaultLLMModel';
import {OpenAIModelConfig} from '../../openAI/openAI.models';
import agentBase from './agentBase';

interface CreateStandaloneAgentParams<T extends ZodTypeAny> {
  name: string;
  role: string;
  instructions: string;
  tools?: Tool<ZodTypeAny>[];
  contexts?: AgentContext[];
  model?: OpenAIModelConfig;
  scratchpad?: (chatId: string) => AgentScratchpadContext;
  responseSchema: T;
}

/**
 * Creates a standalone agent that can be invoked independently without session management.
 */
function standaloneAgent<T extends ZodTypeAny>(
  params: CreateStandaloneAgentParams<T>,
): StandaloneAgent<T> {
  const instructions = `${params.role}

## Instructions
${params.instructions}
  `;

  return agentBase({...params, instructions, model: params.model ?? getDefaultLLMModel()});
}

export default standaloneAgent;
export type {CreateStandaloneAgentParams};
